var map = {
	"./arrow-left.svg": 7485,
	"./arrow-up-white.svg": 5118,
	"./arrow-up.svg": 8770,
	"./crown.svg": 8560,
	"./delete.svg": 4217,
	"./email.svg": 9168,
	"./glass.svg": 7755,
	"./google-focused.svg": 2882,
	"./google.svg": 4966,
	"./home.svg": 2781,
	"./icon-plus.svg": 1179,
	"./icons/facebook.svg": 3902,
	"./icons/twitter.svg": 3961,
	"./images/Autom-logo.png": 779,
	"./images/check.png": 8840,
	"./images/circle-play.png": 5,
	"./images/dragobworld.png": 2649,
	"./images/dragon_crown.png": 5432,
	"./images/not-authorized.png": 9691,
	"./images/telegram.png": 8984,
	"./images/user.png": 4353,
	"./images/verified.png": 4073,
	"./images/video-t.png": 1310,
	"./images/video-thumbnail-bg.jpg": 8809,
	"./images/video-thumbnail.jpeg": 8702,
	"./images/video.png": 6178,
	"./logout-dark.svg": 3781,
	"./logout.svg": 5281,
	"./refresh.svg": 1431,
	"./shield-fill-check.svg": 9803,
	"./shield-fill-x.svg": 8125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;